<template>
  <app-header class="w-full variables-header">
    <div class="flex items-center justify-between w-full gap-4 py-8">
      <div class="flex flex-col gap-1 w-7/12">
        <h2 class="font-semibold">Variables</h2>
        <span>Variables simplify the management of frequently used information, such as phone numbers and opening hours. All variables are shared between all your bots.</span>
      </div>

      <div class="w-4/12">
        <search-input v-model="searchQueryValue"
                      :is-disabled="isLoading"
                      variant="search-variables"
        />
      </div>

      <busy-button id="variable-save-button"
                   :is-loading="isLoading"
                   icon="add"
                   icon-size="1.5rem"
                   variant="primary"
                   :is-disabled="isVariableBeingAdded"
                   @click="addNewVariable"
      >
        <span class="my-auto ml-1">Add</span>
      </busy-button>
    </div>
  </app-header>
</template>

<script>
import AppHeader from '@/components/common/AppHeader.vue'
import SearchInput from '@/components/base-components/SearchInput.vue'
import variablesModule from '@/store/modules/variables.module'
import BusyButton from '@/components/common/BusyButton.vue'

export default {
  name: 'VariablesHeader',

  components: { AppHeader, SearchInput, BusyButton },

  props: {
    searchQuery: {
      type: String,
      default: ''
    }
  },

  computed: {
    variables: variablesModule.variables,
    isLoading: variablesModule.variablesLoading,
    editedId: variablesModule.editedId,
    isVariableBeingAdded: variablesModule.isVariableBeingAdded,

    searchQueryValue: {
      get() {
        return this.searchQuery
      },
      set(value) {
        this.$emit('search-variable', value)
      }
    }
  },

  methods: {
    addNewVariable() {
      if (this.isVariableBeingAdded) return

      this.$emit('add-variable')
    }
  }
}
</script>

<style lang="scss">
.variables-header {
  height: unset !important;
}

#variable-save-button {
  button {
    @apply flex flex-row-reverse;
  }
}
</style>
